import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import Loader from "../../../components/loader/loader";
import { admin_event_view } from "../admin.api";
import "./view.css";
import jwtDecode from "jwt-decode";
import moment from "moment";
export default function View(props) {
  const servInstance = process.env.REACT_APP_BASE_URL;
  let result = servInstance.substring(0, servInstance?.length - 4);
  const [data, setData] = useState({});
  const [isActive, setIsActive] = useState([]);
  const [url, setUrl] = useState("");
  const eventParams = useParams();
  let adminType = Number(jwtDecode(props.state.payload).user_type);

  const fetchEventDetails = () => {
    setIsActive(true);
    admin_event_view(eventParams.id).then((res) => {
      setData(res.data);
      setIsActive(false);
      setUrl(res.current_url);
    });
  };
  useEffect(() => {
    fetchEventDetails();
  }, []);
  const handleDownloadBrochure = (data) => {
    let path = `${result}${data}`;
    window.open(path, "_blank");
  };

  const handleEdit = () => { };
  const backPath =
    data?.event_organized_type === "others"
      ? "/event-list-others"
      : "/event-list-kspace";

  return (
    <div>
      <Loader open={isActive} />
      <div className="view-container ">
        <h6 className="d-flex align-items-center">
          <button
            style={{
              backgroundColor: "#0a223d",
              color: "#fff",
              border: "solid 1px #0a223d",
            }}
            type="button"
            className="btn btn-warning btn-sm  mr-2"
            onClick={(e) => {
              props.history.push(backPath);
            }}
          >
            Back
          </button>
          <b>Event Details</b>
        </h6>

        <hr />
        <div className="data ">
          <div className="row d-flex align-items-center">
            <div className="col-3">Event Name</div>
            <div className="col-1">:</div>
            <div className="col-7">
              {data?.event_title_en}
              <hr />
              {data?.event_title_ma}
            </div>
          </div>
          {data?.event_code &&
            <div className="row d-flex align-items-center">
              <div className="col-3">Event Code</div>
              <div className="col-1">:</div>
              <div className="col-7">
                {data?.event_code}
              </div>
            </div>
          }

          <div className="row  d-flex align-items-center">
            <div className="col-3">Organizer Name</div>
            <div className="col-1">:</div>
            <div className="col-7">
              {data?.oraganized_by_en}
              <hr />
              {data?.oraganized_by_ma}
            </div>
          </div>
          <div className="row  d-flex align-items-center">
            <div className="col-3">Event Description</div>
            <div className="col-1">:</div>
            <div className="col-7">
              <div dangerouslySetInnerHTML={{ __html: data?.events_desc_en }} />
              <hr />
              <div dangerouslySetInnerHTML={{ __html: data?.events_desc_ma }} />
            </div>
          </div>
          <div className="row  d-flex align-items-center">
            <div className="col-3">Venue</div>
            <div className="col-1">:</div>
            <div className="col-7">
              {data?.location_en}
              <hr />
              {data?.location_ma}
            </div>
          </div>
          {data?.event_title_timing && (
            <div className="row  d-flex align-items-center">
              <div className="col-3">Event Timing</div>
              <div className="col-1">:</div>
              <div className="col-7">{data?.event_title_timing}</div>
            </div>
          )}
          {data?.event_date && (
            <div className="row  d-flex align-items-center">
              <div className="col-3">Event Start Date</div>
              <div className="col-1">:</div>
              <div className="col-7">
                {data?.event_date
                  ? moment(data?.event_date).format("DD-MMM-YYYY")
                  : ""}
              </div>
            </div>
          )}
          {data?.event_date_to && (
            <div className="row  d-flex align-items-center">
              <div className="col-3">Event End Date</div>
              <div className="col-1">:</div>
              <div className="col-7">
                {data?.event_date_to
                  ? moment(data?.event_date_to).format("DD-MMM-YYYY")
                  : ""}
              </div>
            </div>
          )}

          {data?.booking_start_date && (
            <div className="row  d-flex align-items-center">
              <div className="col-3">Event Registration Start Date</div>
              <div className="col-1">:</div>
              <div className="col-7">
                {data?.booking_start_date
                  ? moment(data?.booking_start_date).format("DD-MMM-YYYY")
                  : ""}
              </div>
            </div>
          )}
          {data?.booking_close_date && (
            <div className="row  d-flex align-items-center">
              <div className="col-3">Event Registration End Date </div>
              <div className="col-1">:</div>
              <div className="col-7">
                {data.booking_close_date
                  ? moment(data?.booking_close_date).format("DD-MMM-YYYY")
                  : ""}
              </div>
            </div>
          )}
          {data?.event_organized_type === "kspace" && data?.paid !== "0" && (
            <div className="row  d-flex align-items-center">
              <div className="col-3">Fee</div>
              <div className="col-1">:</div>
              <div className="col-7 ">{data?.paid}</div>
            </div>
          )}
          {data?.bank_details && (
            <div className="row  d-flex align-items-center">
              <div className="col-3">Bank Details</div>
              <div className="col-1">:</div>
              <div className="col-7 ">{data?.bank_details}</div>
            </div>
          )}
          {data?.event_contact_no && (
            <div className="row  d-flex align-items-center">
              <div className="col-3">Contact Number</div>
              <div className="col-1">:</div>
              <div className="col-7 ">{data?.event_contact_no}</div>
            </div>
          )}
          {data?.event_email && data?.event_email !== "undefined" && (
            <div className="row  d-flex align-items-center">
              <div className="col-3">Contact Email Id</div>
              <div className="col-1">:</div>
              <div className="col-7 ">{data?.event_email}</div>
            </div>
          )}
          {data?.total_seats && (
            <div className="row  d-flex align-items-center">
              <div className="col-3">Total Seats</div>
              <div className="col-1">:</div>
              <div className="col-7 ">{data?.total_seats}</div>
            </div>
          )}

          {data?.event_image && (
            <div className="row  d-flex align-items-center">
              <div className="col-3">Event Image</div>
              <div className="col-1">:</div>
              <div className="col-7 ">
                <img
                  className="res_photo"
                  src={`${url}/${data?.event_image}`}
                  alt="event image"
                />
              </div>
            </div>
          )}
          {data?.link && (
            <div className="row  d-flex align-items-center">
              <div className="col-3">Website Link</div>
              <div className="col-1">:</div>
              <div className="col-7 break-word ">{data?.link}</div>
            </div>
          )}
          {data?.brochure && (
            <div className="row  d-flex align-items-center">
              <div className="col-3">Brochure</div>
              <div className="col-1">:</div>
              <div className="col-7 ">
                <button
                  className="btn btn-approve btn-success"
                  onClick={(e) => handleDownloadBrochure(data?.brochure)}
                >
                  Download Brochure
                </button>
              </div>
            </div>
          )}
          {data?.registration_types && data?.registration_types.length > 0 && (
            <div className="row d-flex align-items-start mt-4">
              <div className="col-3">Registration Types</div>
              <div className="col-1">:</div>
              <div className="col-7">
                <ul className="list-unstyled">
                  {data?.registration_types.map((reg) => (
                    <li key={reg.id}>
                      <b>{reg?.registration_type}</b> - (DURATION){" "}
                      <b>{reg?.days}</b> - (FEES) <b>₹{reg?.fees}</b> - (SEAT
                      LIMIT) <b>{reg?.seat_limit}</b>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
